<template>
	<div class="mx-auto p-3 sm:p-4 h-100vh">
		<div class="mx-auto md:h-100% flex flex-col">
			<div class="btn-grup flex justify-between pb-3 border-b border-gray-3 mb-3">
				<button
					class="flex flex-row hover:bg-gray-4 items-center rounded py-2 px-4 text-center font-sans mr-2 text-xs font-bold hover:text-primary-500 transition-all bg-transparent border-gray-3 border text-primary"
					type="button" @click="handleBackButtonClick">
					<i class="tabler:arrow-left w-5 h-5 mr-1"></i>
					<span class="hidden md:inline">{{ labels.backbtn }}</span>
				</button>
			</div>
			<div class="Bigaudio-player">
				<BigSoundPlayer :sounds="validPlaylistMode" :darkMode="false" :draggable="false" />
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
import { ref, onMounted, computed, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import axios from 'axios'
import { useAppConfig } from '@/composables/useAppConfig';

import type { Callout, ListFilters, PostListResponse, configCollectionMode } from '@/types';
import { messages } from '@/assets/language';
import { useAppStore } from '@/stores/app-store';

const { currentLng, currentMedicalFilter, currentStudyType, currentstudyMode, currentoutcomeType, currenttargetAudience, currentPublishingFilter, currentAuthoringFilter, currentaplicationDomain, currentDataFilter, currentLatestDays, currentCollectionMode, currentTestyourself, currentPAGE_REQ_ID } = useAppStore()

const AppConfig = useAppConfig();

const filters = [
	currentLng,
	currentPublishingFilter,
	currentAuthoringFilter,
	currentMedicalFilter,
	currentStudyType,
	currentstudyMode,
	currentoutcomeType,
	[currenttargetAudience],
	currentaplicationDomain,
	currentDataFilter,
	currentLatestDays,
	currentCollectionMode,
	currentTestyourself,
	currentPAGE_REQ_ID
	
];

const route = useRoute();
const router = useRouter();

const labels = computed(() => {
	const key = currentLng.value as keyof typeof messages;
	return messages[key] ?? {};
});

// ✅ E përditësuar për të kthyer te faqja e listës me query filters
// const handleBackButtonClick = () => {
// 	router.push({ name: 'list', query: { ...route.query } });
// };
const handleBackButtonClick = () => {
	history.back();
};

const defaultFIlters = () => ({
	search: null,
	author: [],
	outcomeType: [],
	targetAudience: [],
	inputMaterialType: []
});

const listFilters = ref<ListFilters>(defaultFIlters());

const props = defineProps<{
	selectedLanguage?: string
}>();

watch(
	() => props.selectedLanguage,
	(newLang) => {
		if (newLang) {
			console.log(`Gjuha e re nga prindi: ${newLang}`);
		} else {
			console.log('Gjuha nuk është kaluar ende.');
		}
	}
);

const playlistMode = ref<Callout[]>([]);
const validPlaylistMode = computed(() => Array.isArray(playlistMode.value) ? playlistMode.value : []);
const collectionModeData = ref<configCollectionMode | null>(null);


onMounted(async () => {
	try {
		let params: Record<string, any> = {
			...route.query,
			...listFilters.value,
			lng: currentLng.value,
			'collection-mode': currentCollectionMode.value,

		};

		if ( currentMedicalFilter.value ) {
			params.medicalSpeciality = currentMedicalFilter.value;
		}
		if ( currentPublishingFilter.value ) {
			params.publishingStatus = currentPublishingFilter.value;
		}
		if ( currentAuthoringFilter.value ) {
			params.authoringStatus = currentAuthoringFilter.value;
		}
		if ( currentstudyMode.value ) {
			params['flag-mode'] = currentstudyMode.value;
		}
		if ( currentStudyType.value ) {
			params.studyMode = currentStudyType.value;
		}
		if ( currentoutcomeType.value ) {
			params.outcomeType = currentoutcomeType.value;
		}
		if ( currenttargetAudience.value ) {
			params.targetAudience = [currenttargetAudience.value];
		}
		if ( currentaplicationDomain.value ) {
			params.aplicationDomain = [currentaplicationDomain.value];
		}
		if (currentDataFilter.value) {
			params['dashboard-filter'] = currentDataFilter.value
		}

		if (currentLatestDays.value) {
			params['latest-days'] = currentLatestDays.value
		}

		if (currentTestyourself.value) {
			params['testYourself'] = currentTestyourself.value
		}

		if (currentPAGE_REQ_ID.value) {
			params['PAGE_REQ_ID'] = currentPAGE_REQ_ID.value
		}

		if (listFilters.value.allStatuses?.length) {
			params.statuses = listFilters.value.allStatuses;
		}

		const response = await axios.get<PostListResponse>(`${AppConfig.urls.getList}?json=y`, {
			params: params,
			headers: {
				'Content-Type': 'application/json',
				'Accept-Language': currentLng.value
			}
		});

		const jsonData = response.data;
		if (Array.isArray(jsonData.data)) {
			playlistMode.value = jsonData.data;
			//console.log('playlistMode loaded:', playlistMode.value);
		} else {
			console.error('Expected an array but received:', jsonData.data);
			playlistMode.value = [];
		}
		collectionModeData.value = response.data.config
		console.log(collectionModeData.value)

	} catch (error) {
		console.error('Failed to fetch data:', error);
	}
});
</script>


<style>
.Bigaudio-player {
	height: 100%;
	display: flex;
	flex-direction: column;
	position: static;
	top: 0;
}

.Bigaudio-player .soundPlayer {
	transform: translate(0%, 0%);
	width: auto;
	position: unset !important;
	background: transparent;
	height: 100%;
	display: flex;
	flex-direction: column;
	padding: 15px 0;
	box-shadow: none;
}

.Bigaudio-player .soundPlayer-content {
	display: flex;
	align-items: center;
	position: unset;
	box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.1);
	padding: 15px;
	border-radius: 8px;
	margin-bottom: 20px;
	border: 1px solid #ededed;
	background: #fff;
}

.Bigaudio-player .soundPlayer-soundList {
	background: rgb(255 255 255);
	color: #fff;
	width: 100%;
	height: 100%;
	max-height: 750px !important;
	display: flex;
	flex-direction: column;
	padding: 15px;
	position: unset !important;
	transform: translate(0, 0);
}

@media only screen and (max-width: 767px) {
	.Bigaudio-player .soundPlayer-soundList-content {
		overflow-x: hidden;
	}
}

@media only screen and (min-width: 768px) {
	.Bigaudio-player .soundPlayer-soundList-content {
		max-height: 100% !important;
	}
}

.Bigaudio-player .soundPlayer-slider {
	width: 100% !important;
}

.Bigaudio-player .soundPlayer-soundList button {
	margin: 0 !important;
	padding-left: 0;
	padding-right: 0;
}

.Bigaudio-player .soundPlayer-soundList-item:nth-child(n + 2) {
	border-color: rgba(209, 213, 219);
}

@media only screen and (max-width: 767px) {
	.Bigaudio-player .soundPlayer-soundList-content {
		max-height: 100% !important;
		overflow-y: unset !important;
	}
}
</style>
